require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular-resource/index.js
// module id = 445
// module chunks = 0